// extracted by mini-css-extract-plugin
export default {"meteo":"Meteo_meteo__D0s2z","deg":"Meteo_deg__jMhA5","icon":"Meteo_icon__IuT7X"};